import { Link } from 'react-router-dom';
import { selectImage } from '../../../util/misc';
import NotFound from './not-found';
import { useContext } from 'react';
import { CategoriesContext } from '../../../App';
import DownloadCatalogBtn from './elements/download-catalog-btn';

function NewItkCategoryInner() {
    const { currentCategory } = useContext(CategoriesContext);
    if (!currentCategory) {
        return <NotFound>Раздел не найден</NotFound>;
    }
    return (
        <div className="catalog-content catalog-list-page">
            <div className="catalog-nav">
                <DownloadCatalogBtn />
            </div>
            <div className="catalog__grid">
                {currentCategory.children?.map(
                    ({ name, description, slug, url, imageUrl, imageVariants, children }) => {
                        const imgUrl = selectImage(imageVariants, 400, 200, imageUrl);
                        return (
                            <Link key={slug} to={url} className="catalog-item">
                                <div className="catalog-item__img-cont">
                                    <img className="catalog-item__img" src={imgUrl} alt="" />
                                </div>
                                <div className="catalog-item__content">
                                    <div className="catalog-item__head">
                                        <h3 className="catalog-item__title">{name}</h3>
                                        <svg
                                            className="icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#000"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M4 12h16M14 6l6 6-6 6" />
                                        </svg>
                                    </div>
                                    <div className="catalog-item__p">{description}</div>
                                </div>
                            </Link>
                        );
                    }
                )}
            </div>
        </div>
    );
}

export default NewItkCategoryInner;
